import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {useLocation} from "react-router-dom";

import Navbar from "./modules/Navbar";

import UserRoutes from "./UserRoutes";

import useAuth from "./shared/hooks/useAuth";

import { getCurrent } from "./redux/auth/auth-operations";

import './shared/styles/style.scss';
import 'antd/dist/antd.css';

const kanbanRegexp = /^\/missions\/\d+$/

function App() {
    const dispatch = useDispatch();

    const {isLogin} = useAuth();

    useEffect(()=> {
        dispatch(getCurrent());
    }, []);

    const location = useLocation();
    const isKanban = kanbanRegexp.test(location.pathname);

    return (
        <div className="app">
            {isLogin && !isKanban && <Navbar/>}
            <div className="page-wrapper">
                <div className="page-container">
                    <UserRoutes/>
                </div>
            </div>
        </div>
    );
}

export default App;
